import { ClientEnvironment, ClientEnvironmentName } from '../modules/core/types/environment';

export const environment: ClientEnvironment = {
	environmentName: ClientEnvironmentName.DEV,
	apiUrl: 'https://api.iocgpt.com',
	clientUrl: 'https://iocgpt.com',
};
